import ScaleAnswers from './scale-answers';

class Question extends React.Component {
  
  render() {
    return (
      <div className="form-group">
          <label className="control-label">{this.props.label}</label>
          <ScaleAnswers 
            questionName = {this.props.questionName}  
            questionValue = {this.props.questionValue} 
            questionLabel = {this.props.questionLabel}
            handleChange = {this.props.handleChange}
            number = {this.props.number}
          />
      </div>)
  }

};

export default Question;



// WEBPACK FOOTER //
// in/js/components/questions.js